/* eslint-disable react/no-did-mount-set-state */
import React from 'react/addons';

const OnMount = React.createClass({
  propTypes: {
    placeholder: React.PropTypes.element,
    children: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      placeholder: null,
    };
  },

  getInitialState() {
    return {
      mounted: false,
    };
  },

  componentDidMount() {
    this.setState({mounted: true});
  },

  render() {
    const {children, placeholder} = this.props;

    if (this.state.mounted) {
      return children();
    }

    return placeholder;
  }
});

export default OnMount;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/OnMount.jsx
 **/